import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

export type { Database } from './database.types'

type Tables = Database['public']['Tables']

export type Workspace = Tables['workspaces']['Row']
export type WorkspaceInsert = Tables['workspaces']['Insert']
export type WorkspaceUpdate = Tables['workspaces']['Update']

export type Contact = Tables['contacts']['Row']
export type ContactInsert = Tables['contacts']['Insert']
export type ContactUpdate = Tables['contacts']['Update']

export type Conversation = Tables['conversations']['Row']
export type ConversationInsert = Tables['conversations']['Insert']
export type ConversationUpdate = Tables['conversations']['Update']

export type Message = Tables['messages']['Row']
export type MessageInsert = Tables['messages']['Insert']
export type MessageUpdate = Tables['messages']['Update']

export type Deal = Tables['deals']['Row']
export type DealInsert = Tables['deals']['Insert']
export type DealUpdate = Tables['deals']['Update']

export type Invoice = Tables['invoices']['Row']
export type InvoiceInsert = Tables['invoices']['Insert']
export type InvoiceUpdate = Tables['invoices']['Update']

export type Project = Tables['projects']['Row']
export type ProjectInsert = Tables['projects']['Insert']
export type ProjectUpdate = Tables['projects']['Update']

export type ProjectTask = Tables['project_tasks']['Row']
export type ProjectTaskInsert = Tables['project_tasks']['Insert']
export type ProjectTaskUpdate = Tables['project_tasks']['Update']

export type FieldJob = Tables['field_jobs']['Row']
export type FieldJobInsert = Tables['field_jobs']['Insert']
export type FieldJobUpdate = Tables['field_jobs']['Update']

export type ReviewRequest = Tables['review_requests']['Row']
export type ReviewRequestInsert = Tables['review_requests']['Insert']
export type ReviewRequestUpdate = Tables['review_requests']['Update']

export type ReviewRecord = Tables['review_records']['Row']
export type ReviewRecordInsert = Tables['review_records']['Insert']
export type ReviewRecordUpdate = Tables['review_records']['Update']

export type Integration = Tables['integrations']['Row']
export type IntegrationInsert = Tables['integrations']['Insert']
export type IntegrationUpdate = Tables['integrations']['Update']
